import { render, staticRenderFns } from "./PrecheckingsInterventionTable.vue?vue&type=template&id=e8964cd4&"
import script from "./PrecheckingsInterventionTable.vue?vue&type=script&lang=js&"
export * from "./PrecheckingsInterventionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports